import { Route, Switch, useRouteMatch } from "react-router";
import About from "./About/About";
import Contact from "./Contact/Contact";
import Counter from "./LandingPage/Counter";
import Footer from "./LandingPage/Footer";
import Hero from "./LandingPage/Hero";
import HowItWorks from "./LandingPage/HowItWorks";
import NavBar from "./LandingPage/NavBar";
import WhatWeDo from "./LandingPage/WhatWeDo";
import WhyChooseUs from "./LandingPage/WhyChooseUs";

function Homepage() {
    const match = useRouteMatch();
    return (
        <>
            <header>
                <NavBar />
                <Hero />
            </header>
            <main>
                <Switch>
                    <Route path={`${match.path}contact`} exact>
                        <Contact />
                    </Route>
                    <Route path={`${match.path}about`} exact>
                        <About />
                    </Route>
                    <Route path={`${match.path}`} exact>
                        <WhatWeDo />
                        <HowItWorks />
                        <WhyChooseUs />
                        <Counter />
                    </Route>
                </Switch>
                <Footer />
            </main>
        </>
    );
}

export default Homepage;
